import { segment } from '@actions/analytics';
import {
  CLX_LESSON_VIEW,
  CLX_SUCESSFULL_VIEW_FIVE_MINUTES,
  CLX_SUCESSFULL_VIEW_FIFTEEN_MINUTES,
  CLX_CLASS_FEEDBACK_SUBMITTED,
  CLX_LESSON_PDF_DOWNLOADED
} from '@constants/segment';
import segmentStorage from '@events/segmentStorage';

const SEGMENT_CASE_TYPES = {
  LESSON_VIEW: 'LESSON_VIEW',
  SUCESSFULL_VIEW_FIVE_MINUTES: 'SUCESSFULL_VIEW_FIVE_MINUTES',
  SUCESSFULL_VIEW_FIFTEEN_MINUTES: 'SUCESSFULL_VIEW_FIFTEEN_MINUTES',
  FEEDBACK_SUBMITTED: 'FEEDBACK_SUBMITTED',
  PDF_DOWNLOADED: 'PDF_DOWNLOADED'
};

class SegmentEventsUtil {
  constructor(eventType, data) {
    this.eventType = eventType;
    this.data = data;
  }

  sendToSegment = (evt, evtData) => {
    if (evt) segment.track(evt, evtData);
  };

  sendEvents = () => {
    const evts = {
      ...this.data,
      ...segmentStorage.getItem('segmentData', {}),
      last_primary_source_section: segmentStorage.getItem('lpss'),
      last_primary_source: segmentStorage.getItem('lps')
    };
    switch (this.eventType) {
      case SEGMENT_CASE_TYPES.LESSON_VIEW:
        this.sendToSegment(CLX_LESSON_VIEW, evts);
        break;
      case SEGMENT_CASE_TYPES.SUCESSFULL_VIEW_FIVE_MINUTES:
        this.sendToSegment(CLX_SUCESSFULL_VIEW_FIVE_MINUTES, evts);
        break;
      case SEGMENT_CASE_TYPES.SUCESSFULL_VIEW_FIFTEEN_MINUTES:
        this.sendToSegment(CLX_SUCESSFULL_VIEW_FIFTEEN_MINUTES, evts);
        break;
      case SEGMENT_CASE_TYPES.FEEDBACK_SUBMITTED:
        this.sendToSegment(CLX_CLASS_FEEDBACK_SUBMITTED, evts);
        break;
      case SEGMENT_CASE_TYPES.PDF_DOWNLOADED:
        this.sendToSegment(CLX_LESSON_PDF_DOWNLOADED, evts);
        break;
      default:
        return null;
    }
  };
}

export default SegmentEventsUtil;
